import { createTheme, ThemeProvider } from "@mui/material/styles";

import { deDE as coreDeDE } from "@mui/material/locale";


const theme = createTheme({
  palette: {
    mode: "light", // set mode to light
    primary: {
      light: "#1799f0",
      main: "#1799f0",
      dark: "#1799f0",
      contrastText: "#000",
    },
    secondary: {
      light: "#160F25",
      main: "#2d7dee",
      dark: "#0D051D",
      contrastText: "#F6F7F9",
    },
    lightGray: {
      main: "#BCC1CC",
    },
    darkGray: {
      main: "#323334",
    },
    white: {
      main: "#F6F7F9",
    },
    whiteBg: {
      main: "#E3F3FD",
    },
  },
  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontWeight: 500,
    },
    h1: {
      fontSize: 50,
      lineHeight: 1.1,
      letterSpacing: -2,
      fontWeight: 600,
    },
  },

  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-cellCheckbox .MuiDataGrid-checkboxInput": {},
          "& .MuiCheckbox-root.Mui-checked": {
            color: "#6B2DEE", // set the checkbox color to the custom blue color when checked
          },
        },
        row: {
          "&.MuiDataGrid-row": {
            cursor: "pointer",
          },
          "&.Mui-selected": {
            backgroundColor: "#F3EDFF",
            color: "#6B2DEE",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "#E9E0FB",
          },
        },
      },
    },
  },
  coreDeDE,
});


export default theme